import { APP_ROUTES } from 'shared/constants/navigation';
import { COMPLETE_STEP } from 'vendor/constants/WebstoreSetupSteps';

const RequireWebstoreNotComplete = (context) => {
    const { CurrentSetupStep } = context.store.webstore;

    if (CurrentSetupStep === COMPLETE_STEP) {
        return APP_ROUTES.vendor.dashboard;
    }

    return 'next';
};

export default RequireWebstoreNotComplete;
